import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { createSelectable } from 'react-selectable';

import Console from '../../../lib/debug';
import Session from './Session';

const SelectableSession = createSelectable(Session);

class CalendarSession extends Component {
    shouldComponentUpdate(nextProps) {
        return !!nextProps.session;
    }
    render() {
        Console.render('CalendarSessionContent');
        let session = this.props.session;
        let publishTime = this.props.publishTime;
        let sd = moment(session.date, 'YYYY-M-D');
        let publishDate = sd.add(publishTime, 'hours');
        let programId = this.props.programId;
        let dayKey = this.props.dayKey;
        let weekIndex = this.props.weekIndex;
        let dayIndex = this.props.dayIndex;
        let isPreview = this.props.isPreview;
        let selectableKey = (session.id ? session.id : 0) + '_' + dayKey;

        return (
            <SelectableSession
                key={session.id}
                session={session}
                isPubEnabled={false}
                publishDate={publishDate}
                programId={programId}
                isPreview={isPreview}
                weekIndex={weekIndex}
                dayIndex={dayIndex}
                dayKey={dayKey}
                selectableKey={selectableKey}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let publishTime = state.calendar.uiTree.publishTime;
    let session = null;
    try {
        session = state.calendar.sessionTree[ownProps.session.workout_id].data;
    } catch (error) {
        session = null;
    }
    return {
        publishTime,
        session,
        ...ownProps
    };
};

CalendarSession = connect(mapStateToProps)(CalendarSession);

export default CalendarSession;



// WEBPACK FOOTER //
// ./src/view/calendar/components/CalendarSession.jsx